import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/ja';

dayjs.extend(utc);

const UTC_OFFSET_JA = 9;
const SEC_OF = {
  HOUR: 60 * 60,
  DAY: 60 * 60 * 24,
};

export function formatMeetingDate(s: string) {
  return dayjs
    .utc(s)
    .add(UTC_OFFSET_JA, 'h')
    .locale('ja')
    .format('MM/DD(ddd) HH:mm');
}

export function elapsedHours(s: string) {
  const from = dayjs.utc(s);
  const now = dayjs.utc();
  const diffSec = now.diff(from, 's');

  if (diffSec < SEC_OF.HOUR) {
    return '1時間以内';
  } else if (diffSec < SEC_OF.DAY) {
    return `${Math.floor(diffSec / SEC_OF.HOUR)}時間前`;
  } else {
    return from.add(UTC_OFFSET_JA, 'h').format('YYYY/MM/DD');
  }
}

export function formatDateHourMinute(s: string) {
  return dayjs.utc(s).add(UTC_OFFSET_JA, 'h').format('YYYY/MM/DD HH:mm');
}

export function formatMonthDate(s: string) {
  return dayjs.utc(s).add(UTC_OFFSET_JA, 'h').format('MM/DD');
}

export function formatYearMonthDate(s: string) {
  return dayjs.utc(s).add(UTC_OFFSET_JA, 'h').format('YYYY/MM/DD');
}

export function separateNumber(x: number) {
  return String(x).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
}

/** マイナス値の場合は日本慣習に従い '▲' を付与します。 */
export function separateNumberJpnChar(x: number) {
  return separateNumber(x).replace('-', '▲');
}
